import React, { useEffect, useState } from 'react';
import './AppHeader.css';

function measureCropRatios(text: string, font: string) {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    if (!ctx) return { top: 0, bottom: 0 };
    
    ctx.font = font;
    ctx.textBaseline = "alphabetic";
    const metrics = ctx.measureText(text);
    
    const fontAscent = metrics.fontBoundingBoxAscent ?? metrics.actualBoundingBoxAscent;
    const fontDescent = metrics.fontBoundingBoxDescent ?? metrics.actualBoundingBoxDescent;
    
    if (fontAscent === undefined) return { top: 0, bottom: 0 };

    return {
        // Measure at 100px to get an easily computable em ratio
        top: Math.max(0, (fontAscent - metrics.actualBoundingBoxAscent) / 100),
        bottom: Math.max(0, (fontDescent - metrics.actualBoundingBoxDescent) / 100)
    };
}

export default function AppHeader() {
    const [titleCrop, setTitleCrop] = useState({ top: 0, bottom: 0 });
    const [subtitleCrop, setSubtitleCrop] = useState({ top: 0, bottom: 0 });

    useEffect(() => {
        if (typeof document !== 'undefined') {
            document.fonts.ready.then(() => {
                // Measure the invisible padding for BOTH fonts
                setTitleCrop(measureCropRatios("ಪದಕು", "100px 'Anek Kannada'"));
                setSubtitleCrop(measureCropRatios("Kannada Word Puzzles", "100px 'BalooTamma2'"));
            });
        }
    }, []);

    const titleStyle = {
        marginTop: `-${titleCrop.top}em`,
        marginBottom: `-${titleCrop.bottom}em`,
    };

    const subtitleStyle = {
        marginTop: `-${subtitleCrop.top}em`,
        marginBottom: `-${subtitleCrop.bottom}em`,
    };

    return <>
        <header className='App-header'>
            <div className='title-container'>
                <div style={titleStyle}>
                    <h2 className="title-natural">ಪದಕು</h2>
                </div>
                <div style={subtitleStyle}>
                    <p className="subtitle">Kannada Word Puzzles</p>
                </div>
            </div>
        </header>
    </>
}